const authHeader = ()=>{
    const user = localStorage.getItem('userToken')
    if( user ){
        return user
    }else{
        return null
    }
}

export default authHeader